const yogas = [
    {
        name: "Padmasana",
        disc: "Helps deepen meditation by calming the mind and alleviating various physical ailments.",
        src: "cardmeditation.jpg",
        prt: "meditation.jpg",
        link: "https://www.artofliving.org/in-en/yoga/yoga-poses/lotus-pose-padmasana/"
    },
    {
        name: "Vrksasana",
        disc: "Vrksasana is a standing asana that improves balance, focus and mental clarity.",
        src: "cardtree.jpg",
        prt: "tree (2).jpg",
        link: "https://www.artofliving.org/in-en/yoga/yoga-poses/tree-pose-vrikshasana/"
    },
    {
        name: "Tadasana",
        disc: "It improves posture, opens up the chest and lengthens the spine ·",
        src: "cardtadasana.jpg",
        prt: "tadasana.jpg",
        link: "https://www.artofliving.org/in-en/yoga/yoga-poses/mountain-pose-tadasana/"
    },
    {
        name: "Utkatasana",
        disc: "Strengthens the thighs and ankles, while toning the shoulders, butt, hips, and back",
        src: "cardchairpose.jpg",
        prt: "squat.jpg",
        link: "https://www.artofliving.org/in-en/yoga/yoga-poses/chair-pose-utkatasana/"
    },
    {
        name: "Virbhadrasana",
        disc: "An incarnation of Shiva, this version of Warrior Pose increases stamina.",
        src: "cardwarrior.jpg",
        prt: "warrior.jpg",
        link: "https://www.artofliving.org/in-en/yoga/yoga-poses/warrior-pose-virbhadrasana/"
    },
    {
        name: "Devi Asana",
        disc: "aka Utkata Konasana strengthens the hips, the lower back and the thigh muscles.",
        src: "cardgoddess.jpg",
        prt: "goddess.jpg",
        link: "https://www.yogicwayoflife.com/utkata-konasana-the-goddess-pose/"
    },
]

export default yogas;